export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const PLAY = 'PLAY'
export const SIGNOUT = 'SIGNOUT'

export const FETCH_AGENTS = 'FETCH_AGENTS'


export const FETCH_BETRECORDS = 'FETCH_BETRECORDS'

export const FETCH_AGENTAMOUNTREPORT = 'FETCH_AGENTAMOUNTREPORT'

export const FETCH_PROFITLOSSREPORT = 'FETCH_PROFITLOSSREPORT'

// OLD
export const FETCH_TASKS = 'FETCH_TASKS'
export const FETCH_VENDORS = 'FETCH_VENDORS'
export const CREATE_TASK = 'CREATE_TASK'
export const UPDATE_TASK = 'UPDATE_TASK'
export const DELETE_TASK = 'DELETE_TASK'
export const CLEAR_COMPLETED_TASKS = 'CLEAR_COMPLETED_TASKS'

export const FETCH_WITHDRAWALS = 'FETCH_WITHDRAWALS'
export const FETCH_WITHDRAWAL = 'FETCH_WITHDRAWAL'
export const APPROVE_WITHDRAWAL = 'APPROVE_WITHDRAWAL'
export const DECLINE_WITHDRAWAL = 'DECLINE_WITHDRAWAL'
export const CREATE_WITHDRAWAL = 'CREATE_WITHDRAWAL'

export const FETCH_DEPOSITS = 'FETCH_DEPOSITS'
export const FETCH_DEPOSIT = 'FETCH_DEPOSIT'
export const APPROVE_DEPOSIT = 'APPROVE_DEPOSIT'
export const DECLINE_DEPOSIT = 'DECLINE_DEPOSIT'
export const CREATE_DEPOSITS = 'CREATE_DEPOSITS'

export const FETCH_USERS = 'FETCH_USERS'
export const FETCH_USER = 'FETCH_USER'
export const CREATE_USER = 'CREATE_USER'
export const UPDATE_USER = 'UPDATE_USER'
export const DELETE_USER = 'DELETE_USER'

export const CREATE_TAB = 'CREATE_TAB'
export const DELETE_TAB = 'DELETE_TAB'

export const FETCH_AGENTCHILDS = 'FETCH_AGENTCHILDS'
export const CREATE_AGENTCHILD = 'CREATE_AGENTCHILD'
export const DELETE_AGENTCHILD = 'DELETE_AGENTCHILD'
export const UPDATE_AGENTCHILDS = 'UPDATE_AGENTCHILDS'

export const FETCH_AGENTCLIENTS = 'FETCH_AGENTCLIENTS'
export const CREATE_AGENTCLIENT = 'CREATE_AGENTCLIENT'
export const DELETE_AGENTCLIENT = 'DELETE_AGENTCLIENT'
export const UPDATE_AGENTCLIENT = 'UPDATE_AGENTCLIENT'

export const FETCH_AGENTSUBACCOUNTS = 'FETCH_AGENTSUBACCOUNTS'
export const CREATE_AGENTSUBACCOUNT = 'CREATE_AGENTSUBACCOUNT'
export const DELETE_AGENTSUBACCOUNT = 'DELETE_AGENTSUBACCOUNT'
export const UPDATE_AGENTSUBACCOUNT = 'UPDATE_AGENTSUBACCOUNT'

export const CURRENCY_FORMAT = 'CURRENCY_FORMAT'
export const FETCH_BETLIMIT = 'FETCH_BETLIMIT'

export const CREATE_IPLIST = 'CREATE_IPLIST'
export const UPDATE_IPLIST = 'UPDATE_IPLIST'

export const UPDATE_BALANCE = 'UPDATE_BALANCE'

export const UNLOCK_USER = 'UNLOCK_USER'
export const LOCK_USER = 'LOCK_USER'

export const ENABLE_USER = 'ENABLE_USER'
export const DISABLE_USER = 'DISABLE_USER'

export const LOCKBET_USER = 'LOCKBET_USER'
export const UNLOCKBET_USER = 'UNLOCKBET_USER'

export const FETCH_CUREXCHANGE = 'FETCH_CUREXCHANGE'
export const FETCH_AGENTCREDITREPORTS = 'FETCH_AGENTCREDITREPORTS'

export const FETCH_CLIENTCREDITREPORTS = 'FETCH_CLIENTCREDITREPORTS'


export const FETCH_LOGREPORTS = 'FETCH_LOGREPORTS'

export const CHANGE_PASSWORD = 'CHANGE_PASSWORD'

export const CLAIM_REBATE = 'CLAIM_REBATE'

export const FETCH_REBATEREPORTS = 'FETCH_REBATEREPORTS'



